import { useState, useEffect } from 'react';
import { Form, Button, FormGroup, Label, Input } from 'reactstrap';
import axios from 'axios';
import Select from 'react-select';

import { URL_APPEND, reactSelectStyles } from '@general/constants'
import SelectBill from './SelectBIll';


const BillTrackerForm = (props) => {
    let [formData, setFormData] = useState({});
    let trackerUrl = `${URL_APPEND}/api/tracker/`;

    let submitForm = (e) => {
        e.preventDefault();
        axios.post(trackerUrl, formData).then(res => console.log('saved'));
        // alert('submitted')
    }

    return (
        <form onSubmit={(e) => props.submitForm ? props.submitForm(e, formData) : submitForm} ref={props.formRef}>
            <FormGroup>
                <Label>Bill</Label>
                <SelectBill
                    onChange={sel => {
                        setFormData({ ...formData, bill: sel.value })
                        props.setSelBill && props.setSelBill(sel)
                        props.setPerformedAjax && props.setPerformedAjax(false)
                    }}>
                </SelectBill>
            </FormGroup>
            <FormGroup>
                <Label>Stage</Label>
                <Select
                    styles={reactSelectStyles}
                    placeholder='Stage...'
                    options={
                        ['First reading',
                            'Second reading',
                            'Committee Stage',
                            'Third Reading',
                            'Presidential Assent',
                            'Passed On'
                        ].map(el => ({ value: el, label: el }))
                    }
                    onChange={sel => {
                        setFormData({ ...formData, stage: sel.value })
                    }}
                    
                />
            </FormGroup>
            <FormGroup>
                <Label>Publication Date</Label>
                <Input
                    type='date'
                    onChange={e => setFormData({ ...formData, stage_date: e.target.value })}
                />
            </FormGroup>
            <FormGroup>
                <Label>Description</Label>
                <Input
                    placeholder='further description...'
                    type='textarea'
                    onChange={e => setFormData({ ...formData, details: e.target.value })}
                />
            </FormGroup>
            <FormGroup>
                <Button outline color="success">Save</Button>
            </FormGroup>
        </form>
    )
}

export default BillTrackerForm;